/* @flow weak */
import { apiPost } from '../lib/api'

export const SIGN_IN_START = 'SIGN_IN_START'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR'

export const SIGN_USER_OUT_START = 'SIGN_USER_OUT_START'
export const SIGN_USER_OUT_SUCCESS = 'SIGN_USER_OUT_SUCCESS'
export const SIGN_USER_OUT_ERROR = 'SIGN_USER_OUT_ERROR'

export const SOCIAL_AUTH_FACEBOOK_START = 'SOCIAL_AUTH_FACEBOOK_START'
export const SOCIAL_AUTH_FACEBOOK_SUCCESS = 'SOCIAL_AUTH_FACEBOOK_SUCCESS'
export const SOCIAL_AUTH_FACEBOOK_ERROR = 'SOCIAL_AUTH_FACEBOOK_ERROR'

export const SOCIAL_AUTH_GOOGLE_START = 'SOCIAL_AUTH_GOOGLE_START'
export const SOCIAL_AUTH_GOOGLE_SUCCESS = 'SOCIAL_AUTH_GOOGLE_SUCCESS'
export const SOCIAL_AUTH_GOOGLE_ERROR = 'SOCIAL_AUTH_GOOGLE_ERROR'

export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'

export const RESET_PASSWORD_START = 'RESET_PASSWORD_START'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'

export const CHANGE_PASSWORD_START = 'CHANGE_PASSWORD_START'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'

export const FORGOTTEN_PASSWORD_START = 'FORGOTTEN_PASSWORD_START'
export const FORGOTTEN_PASSWORD_SUCCESS = 'FORGOTTEN_PASSWORD_SUCCESS'
export const FORGOTTEN_PASSWORD_ERROR = 'FORGOTTEN_PASSWORD_ERROR'

export const SIGN_OUT = 'SIGN_OUT'

export const signIn = (body) => ({ getState, fetch }) => ({
  type: 'SIGN_IN',
  payload: apiPost({
    fetch,
    endpoint: 'users/sign-in',
    getState,
    body,
  }),
})

export const forgotPassword = ({ email }) => ({ getState, fetch }) => ({
  type: 'FORGOT_PASSWORD',
  payload: apiPost({
    fetch,
    endpoint: 'users/forgot-password',
    getState,
    body: {
      email,
    },
  }),
})

export const resetPassword = ({ password, passwordConfirm, hash }) =>
({ getState, fetch }) => ({
  type: 'RESET_PASSWORD',
  payload: apiPost({
    fetch,
    endpoint: 'users/reset-password',
    getState,
    body: {
      password,
      passwordConfirm,
      hash,
    },
  }),
})

export const signOut = () => ({
  type: SIGN_OUT,
})

export const signUserOut = (id) => ({ getState, fetch }) => ({
  type: 'SIGN_USER_OUT',
  payload: apiPost({
    fetch,
    endpoint: `users/sign-out/${id}`,
    getState,
  }),
})

export const facebookAuth = (body) =>
  ({ getState, fetch }) => ({
    type: 'SOCIAL_AUTH_FACEBOOK',
    payload: apiPost({
      fetch,
      endpoint: 'users/facebook',
      getState,
      body,
    }),
  })

export const googleAuth = (body) => ({ getState, fetch }) => ({
  type: 'SOCIAL_AUTH_GOOGLE',
  payload: apiPost({
    fetch,
    endpoint: 'users/google',
    getState,
    body,
  }),
})

export const changePassword = (body) => ({ getState, fetch }) => ({
  type: 'CHANGE_PASSWORD',
  payload: apiPost({
    fetch,
    endpoint: 'users/change-password',
    getState,
    body,
  }),
})

export const forgottenPassword = (body) => ({ getState, fetch }) => ({
  type: 'FORGOTTEN_PASSWORD',
  payload: apiPost({
    fetch,
    endpoint: 'users/forgot-password',
    getState,
    body,
  }),
})



// WEBPACK FOOTER //
// ./src/common/auth/actions.js